const de = {
  controlsTitle: 'Was suchen Sie?',
  roomApartment: 'Wohnung mit FLATSIZE Zimmern',
  room: 'Zimmer',
  budgetUpTo: 'Budget bis',
  offers: 'Angebote',
  areRoomApartments: 'Wohnungen mit FLATSIZE Zimmern',
  areInBudgetOf: 'sind im Budget von',
  areNotInBudget: 'sind nicht im Budget',
  inBudget: 'sind im Budget',
  fewOffers: 'Weniger als 50 Angebote',
  bfsIdParamName: 'gemeinde',
  tablesearch: {
    placeholder: 'Nach Gemeinde suchen',
    noResults:
      'Die Gemeinde wurde nicht gefunden.',
    clear: 'Löschen',
    search: 'Suchen',
  },
  maptitle_1: 'Verteilung von «',
  maptitle_2: '» in der Schweiz',
  namesearch: {
    placeholder: 'Nachnamen suchen',
    noResults:
      'Nichts gefunden. Entweder kommt dieser Name in der Schweiz weniger als dreimal vor oder er war 2024 noch nicht in der Statistik erfasst.',
    clear: 'Löschen',
    search: 'Suchen',
  },
  maptitle: (
    <>
      Gemeinden, in denen dieser Name
     mindestens dreimal vorkommt
    </>
  ),
  searchtitle: 'Suchen Sie Ihren Nachnamen:',
  hint1:
    'Die Suche umfasst aus Datenschutzgründen nur Namen, die in der Schweizer Statistik im Jahr 2024 mindestens dreimal vorkamen.',
  nomapdata:
    'Dieser Name kommt in keiner Gemeinde mindestens dreimal vor. Daher können wir Ihnen hier keine Karte anzeigen.',
  sortToggleLabels: ['', 'Absolut', 'Relativ'],
  tableTitle: 'Gemeindeliste',
  tableHint:
    'Die Tabelle enthält aus Datenschutzgründen nur Namen, die in der Schweizer Statistik mindestens dreimal vorkommen.',
  nameTableCols: ['Gemeinde', 'Kanton', 'Absolut', 'Relativ'],
  showAll: 'Alle anzeigen',
  showLess: 'Weniger anzeigen',
  allTableTitle: 'Gesamte Schweiz',
  loading: 'Daten werden geladen...',
  allNameTableCols: ['Rang', 'Name', 'Absolut', 'Relativ'],
  allNameTableShowMore: 'Top 100 anzeigen',
  allNameTableShowLess: 'Nur Top 10 anzeigen',
  seachMunicipality: 'Gemeinde suchen',
}
const fr = {
  controlsTitle: 'Que cherchez-vous?',
  roomApartment: 'Appartement avec FLATSIZE pièces',
  room: 'chambre',
  budgetUpTo: "Budget jusqu'à",
  offers: 'offres',
  areRoomApartments: 'appartements de FLATSIZE pièces',
  areInBudgetOf: 'sont dans le budget de',
  areNotInBudget: 'ne sont pas dans le budget',
  inBudget: 'sont dans les budget',
  fewOffers: 'Moins de 50 offres',
  bfsIdParamName: 'commune',
  tablesearch: {
    placeholder: 'Chercher dans la liste',
    noResults: 'La commune n\'a pas été trouvée.',
    clear: 'Effacer',
    search: 'Chercher',
  },
  maptitle_1: 'Répartition de',
  maptitle_2: 'en Suisse',
  namesearch: {
    placeholder: 'Rechercher par nom',
    noResults: 'Rien trouvé',
    clear: 'Effacer',
    search: 'Chercher',
  },
  maptitle: (
    <>
      Communes où ce nom
      <br />
      apparaît au moins trois fois
    </>
  ),
  searchtitle: 'Cherchez votre nom de famille:',
  hint1:
    'Pour des raisons de protection des données, seuls les noms qui sont apparus au moins trois fois en Suisse en 2024 ont été pris en compte.',
  nomapdata:
    "Ce nom n'apparaît dans aucune commune au moins trois fois. Nous ne pouvons donc pas vous montrer de carte ici.",
  sortToggleLabels: ['', 'Nombre', 'Taux'],
  tableTitle: 'Liste des communes',
  tableHint:
    'Pour des raisons de protection des données, le tableau ne contient que les noms qui apparaissent au moins trois fois en Suisse.',
  nameTableCols: ['Commune', 'Canton', 'Nombre', 'Taux'],
  showAll: 'Tout afficher',
  showLess: 'Afficher moins',
  allTableTitle: 'Toute la Suisse',
  loading: 'Chargement des données...',
  allNameTableCols: ['Rang', 'Nom', 'Nombre', 'Taux'],
  allNameTableShowMore: 'Afficher les 100 premiers',
  allNameTableShowLess: 'Afficher seulement les 10 premiers',
  seachMunicipality: 'Rechercher une commune',
}
export { de, fr }
